import * as React from 'react'
import { observer } from 'mobx-react'
import { FormattedMessage } from 'react-intl'
import { IReviewModel, IUser, IInviter } from '../../models'
import './ReviewUsers.scss'

interface IReviewUsers {
  reviewModel: IReviewModel,
  users: Array<IUser>,
  inviters: Array<IInviter>
}

interface IFullList {
  name: string,
  type: string
}

@observer
export default class ReviewUsers extends React.Component<IReviewUsers> {
  fullNameSet: Array<IFullList>

  render() {
    const { users, inviters } = this.props

    const fullSetUsers = users.map((user) => {
      return { name: user.name, type: 'user' }
    }).filter(user => user.name)

    const fullSetInviters = inviters.map((inviter) => {
      return { name: inviter.name, type: 'inviter' }
    })
    this.fullNameSet = fullSetInviters.concat(fullSetUsers)

    return (
      <div className="review-users-container">
        <FormattedMessage id="review.users.members" />
        {
          this.fullNameSet.sort((user1, user2) => {
            return user1.name.localeCompare(user2.name)
          }).map((user) => {
            return (
              <div className="members">
                {user.name}
                { user.type === 'inviter'
                  ? <FormattedMessage id="sidebar.slide.editor" />
                  : null
                }
              </div>
            )
          })
        }
      </div>
    )
  }
}
